import React, { useState } from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import { isSmallBreakpoint } from '../../../utils';
import Tip from './Tip';

const Tips = ({ tips, currentBreakpoint }) => {
  const [selectedTip, setSelectedTip] = useState(0);
  const isSmall = isSmallBreakpoint({ currentBreakpoint });

  const handleKeyDown = (event, index) => {
    if (event.key === 'Enter' || event.key === ' ') {
      setSelectedTip(index);
    }
  };

  return (
    <div className="tips">
      <div className="grid-container">
        <div className="grid-x align-center">
          <div className="cell xsmall-16 medium-14">
            <h3 className="tips__heading">{R.prop('title', tips)}</h3>

            {isSmall && (
              <div className="tips__steps">
                {R.prop(['tip'], tips).map(
                  ({ image, mobile_title: mobileTitle }, index) => (
                    <div
                      key={index}
                      role="button"
                      tabIndex="0"
                      className="tips__step"
                      onClick={() => setSelectedTip(index)}
                      onKeyDown={(event) => handleKeyDown(event, index)}
                    >
                      <div
                        className={`tips__step__image ${
                          index === selectedTip ? 'selected' : ''
                        }`}
                      >
                        <img
                          src={R.prop('url', image)}
                          alt={R.prop('title', image)}
                        />
                      </div>
                      <p>{mobileTitle}</p>
                    </div>
                  )
                )}
              </div>
            )}

            <div className="tips__grid">
              {R.prop(['tip'], tips).map(
                ({ description, image }, index) =>
                  (isSmall ? index === selectedTip : true) && (
                    <Tip
                      key={index}
                      index={index}
                      description={description}
                      image={image}
                    />
                  )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Tips.propTypes = {
  tips: PropTypes.objectOf(PropTypes.object),
  currentBreakpoint: PropTypes.string,
};

export default Tips;
